const transformMedications = (res = []) => {
  const outputObj = {};
  const activeMedications = res?.results?.filter((data) => data?.status === 'active');
  outputObj.medicationNames = activeMedications?.map((medication) => medication.text);
  outputObj.medicationLastUpdated = res?.results?.[0]?.updatedAt ?? res?.results?.[0]?.createdAt;
  return outputObj;
};

export default transformMedications;
